import { VoidCallback1 } from '@deqo/foundation';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Colors } from './Colors';
import { tapOrClick } from './TapOrClick';
import { toRem } from './Utils';

const frameSize = (size: string) => size === 'sm' ? 2.5 : 2.75;
const trackSize = (size: string) => size === 'sm' ? 1.25 : 1.5;
const ballSize = (size: string) => size === 'sm' ? 1 : 1.25;
const travelSize = (size: string) => size === 'sm' ? 1.5 : 1.25;

export type ToggleProps = {
    size?: 'md' | 'sm',
    value?: boolean,
    onAction?: VoidCallback1<boolean>,
};

export const Toggle = ({ size, value, onAction }: ToggleProps) => {
    const onTapOrClick = useCallback(() => {
        if (onAction) onAction(!value);
    }, [value, onAction]);
    return <Frame tabIndex={0} active={!!value} size={size} {...tapOrClick(onTapOrClick)}>
        <Ball active={!!value} size={size} />
    </Frame>;
};

const Frame = styled.div<any>`
    width: ${p => toRem(frameSize(p.size))};
    position: relative;
    height: ${p => toRem(trackSize(p.size))};
    box-sizing: border-box;
    border-width: 2px;
    border-radius: 9999px;
    border-color: transparent;
    background-color: ${p => p.active ? Colors.primary : '#e5e7eb'};
    transition: 200ms cubic-bezier(.4,0,.2,1);
    transition-property: background-color,border-color,color,fill,stroke;
    cursor: pointer;

    &:focus {
        outline: 0;
        box-shadow: 0 0 0 .125rem ${Colors.primary};
    }
`;

const Ball = styled.div<any>`
    width: ${p => toRem(ballSize(p.size))};
    height: ${p => toRem(ballSize(p.size))};
    border-radius: 9999px;
    background-color: #fff;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px 0 rgba(0,0,0,.06);
    transform: translateX(${p => p.active ? 1.25 : 0}rem);
    transition: 200ms cubic-bezier(.4,0,.2,1);
    transition-property: background-color,border-color,color,fill,stroke,opacity,box-shadow,transform;
`;

